import { Mail } from 'lucide-react'

type Props = {
  mailboxAddress: string | null
  multipleMailboxesAttached: boolean
}

/**
 * Small caption below the email body preview clarifying which sender
 * mailbox's signature is shown. Reminds operators that round-robin
 * assignment at send time may produce a different signature than the
 * preview when multiple mailboxes are attached.
 */
export function SignatureDisclaimer({
  mailboxAddress,
  multipleMailboxesAttached,
}: Props) {
  const message = !mailboxAddress ? (
    'Signature is appended at send time.'
  ) : multipleMailboxesAttached ? (
    <>
      Preview using signature for <code>{mailboxAddress}</code>. Actual send
      uses round-robin assignment across attached mailboxes. Use &ldquo;Send
      test email&rdquo; to verify exact bytes for a specific contact.
    </>
  ) : (
    <>
      Preview using signature for <code>{mailboxAddress}</code>.
    </>
  )
  return (
    <p className="mt-1.5 flex items-start gap-2 text-xs leading-relaxed text-fg-secondary">
      <Mail className="mt-0.5 size-3.5 shrink-0 text-brand" />
      <span>{message}</span>
    </p>
  )
}
